import React, { Component } from 'react';
import Geosuggest from 'react-geosuggest';
import classNames from 'classnames';
import { sortBy } from 'lodash';
import './style.css';
import './icon.css';
import './pickup.css';
import './delivery.css';
import storeConfig from '../../configuration/storeConfig';
import getImage from '../NewMenuItem/getImage';

class OrderType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFlow: 'initial',
      stage: 100,
      isBackClicked: false,
      slideAwayScreen: false,
      slideIntoScreen: false,
      supportedSubs: [],
      showAreaNotServicableMessage: false,
      availablePickupStores: [],
      sortedAvailablePickupStores: [],
    };
  }

  componentDidMount() {
    if (this.props.stores && this.props.settings) {
      let availablePickupStores = [];
      this.props.stores.forEach((store) => {
        if (this.storeAvailableForService(store, 'pickup')) {
          availablePickupStores.push(store);
        }
      });
      this.setState({
        availablePickupStores,
      });
    }
  }

  componentWillReceiveProps(props) {
    if (props.stores && props.settings) {
      let availablePickupStores = [];
      props.stores.forEach((store) => {
        if (this.storeAvailableForService(store, 'pickup')) {
          availablePickupStores.push(store);
        }
      });
      this.setState({
        availablePickupStores,
      });
    }
  }

  setSelectedFlow = (flow) => {
    this.setState(
      {
        slideAwayScreen: true,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              selectedFlow: flow,
              slideAwayScreen: false,
            },
            () => {
              // if (this.state.selectedFlow === 'pickup') {
              //   if (this.state.isStoresSorted === false) {
              //     this.requestLocation();
              //   }
              // }
              if (this.state.selectedFlow === 'delivery') {
                this.setState({
                  supportedSubs: [],
                  showAreaNotServicableMessage: false,
                });
              }
            }
          );
        }, 200);
      }
    );
  };

  handleBackClickFromPickup = () => {
    this.setState(
      {
        isBackClicked: true,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              selectedFlow: 'initial',
            },
            () => {
              setTimeout(() => {
                this.setState({
                  isBackClicked: false,
                });
              }, 200);
            }
          );
        }, 200);
      }
    );
  };

  handleBackClickFromDelivery = () => {
    this.setState(
      {
        isBackClicked: true,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              selectedFlow: 'initial',
            },
            () => {
              setTimeout(() => {
                this.setState({
                  isBackClicked: false,
                });
              }, 200);
            }
          );
        }, 200);
      }
    );
  };

  handleBackClickFromPickup = () => {
    this.setState(
      {
        isBackClicked: true,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              selectedFlow: 'initial',
            },
            () => {
              setTimeout(() => {
                this.setState({
                  isBackClicked: false,
                });
              }, 200);
            }
          );
        }, 200);
      }
    );
  };

  // locationApproved = (position) => {
  //   this.setState(
  //     {
  //       ...this.state,
  //       location: {
  //         lat: position.coords.latitude,
  //         long: position.coords.longitude,
  //       },
  //     },
  //     () => {
  //       const customerLocation = {
  //         ...this.state.location,
  //         // lat: -38.4452993,
  //         // long: 144.6357204,
  //       };
  //       const storeLocations = this.state.availablePickupStores.map((store) => {
  //         return {
  //           long: store.addressLocation.long,
  //           lat: store.addressLocation.lat,
  //           storeId: store._id,
  //         };
  //       });

  //       const distancesFromStore = storeLocations.map((storeLocation) => {
  //         return new Promise((resolve, reject) => {
  //           fetch(
  //             `https://osrm-api.nextorder.co/route/v1/car/${customerLocation.long},${customerLocation.lat};${storeLocation.long},${storeLocation.lat}`
  //           )
  //             .then((response) => response.json())
  //             .then((distanceObj) => {
  //               if (distanceObj.routes[0] && distanceObj.routes[0].distance) {
  //                 let distance = {
  //                   distance: Number(
  //                     (distanceObj.routes[0].distance / 1000).toFixed(2)
  //                   ),
  //                   storeId: storeLocation.storeId,
  //                 };
  //                 resolve(distance);
  //               } else {
  //                 resolve({ distance: null, storeId: storeLocation.storeId });
  //               }
  //             })
  //             .catch((error) => {
  //               reject(error);
  //             });
  //         });
  //       });

  //       Promise.all(distancesFromStore)
  //         .then((responses) => {
  //           console.log('Responses from OSRM', responses);
  //           this.sortRestaurants(responses);
  //         })
  //         .catch((error) => {
  //           console.log('Error from OSRM', error);
  //         });
  //     }
  //   );
  // };

  // sortRestaurants = (restaurantsWithDistance) => {
  //   let availableRestaurants = [...this.state.availablePickupStores];
  //   availableRestaurants.forEach((restaurant) => {
  //     restaurantsWithDistance.forEach((restaurantWithDistance) => {
  //       if (restaurant._id === restaurantWithDistance.storeId) {
  //         restaurant.distance = restaurantWithDistance.distance;
  //       }
  //     });
  //   });
  //   const restaurantsSorted = sortBy(availableRestaurants, ['distance']);
  //   this.setState({
  //     availablePickupStores: restaurantsSorted,
  //     isStoresSorted: true,
  //   });
  // };

  // locationDenied = (err) => {
  //   console.log('err', err);
  // };

  // requestLocation = () => {
  //   navigator.geolocation.getCurrentPosition(
  //     this.locationApproved,
  //     this.locationDenied
  //   );
  // };

  storeAvailableForService = (s, type) => {
    if (type === 'pickup') {
      let settings = this.props.settings
        ? this.props.settings.filter((f) => f.storeId === s._id)
        : [];
      if (settings.some((s) => s.isPickupOn === true)) return true;
      else return false;
    } else if (type === 'delivery') {
      let settings = this.props.settings
        ? this.props.settings.filter((f) => f.storeId === s._id)
        : [];
      if (settings.some((s) => s.isDeliveryOn === true)) return true;
      else return false;
    } else if (type === 'tablebooking') {
      let settings = this.props.settings
        ? this.props.settings.filter((f) => f.storeId === s._id)
        : [];
      if (settings.some((s) => s.isDeliveryOn === true)) return true;
      else return false;
    } else if (type === 'delivery-list') {
      if (this.state.supportedSubs) {
        let matchingSuburbs = this.state.supportedSubs.filter((f) => {
          return f.storeId === s._id;
        });
        if (matchingSuburbs.length > 0) return true;
        else return false;
      } else return false;
    } else return true;
  };

  openStoreWebsite = (e, url) => {
    e.preventDefault();
    window.open(url, '_self');
  };

  openStoreWebsiteDel = (e, store) => {
    e.preventDefault();
    let finalUrl = '';
    if (
      this.state.supportedSubs &&
      this.state.address &&
      this.state.addressLocation &&
      this.state.placeId
    ) {
      let matchingSuburbs = this.state.supportedSubs.filter((f) => {
        return f.storeId === store._id;
      });
      if (matchingSuburbs.length > 0) {
        finalUrl = `${store.baseUrl}?type=delivery&address=${this.state.address}&lat=${this.state.addressLocation.lat}&lng=${this.state.addressLocation.lng}&placeId=${this.state.placeId}&suburbId=${matchingSuburbs[0]._id}&deliveryCost=${matchingSuburbs[0].deliveryCost}&minOrderValue=${matchingSuburbs[0].minOrderValue}&areaCode=${this.state.areaCode}&area=${this.state.area}`;
        console.log(finalUrl);
        window.open(finalUrl, '_self');
      }
    }
  };

  skipSuggest = (suggest) => {
    try {
      let suburbWithState = suggest.description.replace(
        `, ${storeConfig.stores[0].country}`,
        ''
      );
      let suburbArray = suburbWithState.split(',');
      let sub;
      if (suburbArray.length === 5) {
        sub = suburbArray[4].trim();
      } else if (suburbArray.length === 4) {
        sub = suburbArray[3].trim();
      } else if (suburbArray.length === 3) {
        sub = suburbArray[2].trim();
      } else {
        sub = suburbArray[1].trim();
      }
      let stateArr = sub.split(' ');
      let state = stateArr[stateArr.length - 1];

      if (
        state.toLowerCase() !==
          storeConfig.stores[0].stateIdentifier.toLowerCase() &&
        state.toLowerCase() !== storeConfig.stores[0].state.toLowerCase()
      )
        return true;
      else return false;
    } catch (err) {
      return false;
    }
  };

  updateDeliveryAddress = (addObj) => {
    if (addObj) {
      let subArray = addObj.label.split(',');
      let sub = '';
      let area = '';
      let areaCode = '';

      if (subArray.length === 5) {
        sub =
          addObj.label.split(',')[4] &&
          addObj.label.split(',')[4].trim().toLowerCase();
      } else if (subArray.length === 4) {
        sub =
          addObj.label.split(',')[3] &&
          addObj.label.split(',')[3].trim().toLowerCase();
      } else if (subArray.length === 3) {
        sub =
          addObj.label.split(',')[2] &&
          addObj.label.split(',')[2].trim().toLowerCase();
      } else {
        sub =
          addObj.label.split(',')[1] &&
          addObj.label.split(',')[1].trim().toLowerCase();
      }
      if (this.props.suburbs && this.props.suburbs.length > 0) {
        let supportedSubs = this.props.suburbs.filter((s) => {
          return sub === s.name.toLowerCase();
        });
        console.log('supportedSubs', supportedSubs);
        if (supportedSubs && supportedSubs.length > 0) {
          if (addObj.gmaps?.address_components?.length > 0) {
            addObj.gmaps.address_components.map((addressComponent) => {
              if (addressComponent.types && addressComponent.types.length > 0) {
                addressComponent.types.forEach((type) => {
                  if (type === 'postal_code') {
                    areaCode = addressComponent.long_name
                      ? addressComponent.long_name
                      : 0;
                  }
                  if (type === 'locality') {
                    area = addressComponent.long_name
                      ? addressComponent.long_name
                      : '';
                  }
                });
              }
              return addressComponent;
            });
          }

          this.setState({
            supportedSubs,
            address: addObj.label.trim(),
            addressLocation: addObj.location,
            placeId: addObj.placeId,
            showAreaNotServicableMessage: false,
            areaCode,
            area,
          });
        } else {
          this.setState({
            supportedSubs: [],
            showAreaNotServicableMessage: true,
          });
        }
      } else {
        this.setState({ supportedSubs: [] });
      }
    }
  };

  render() {
    const initialScreenClass = classNames({
      'sot-inner-box': true,
      slideAway: this.state.slideAwayScreen === true,
      slideLeft: this.state.isBackClicked === true,
    });

    const pickupScreenClass = classNames({
      'sot-inner-box': true,
      'section-pickup-location': true,
      slideRight: this.state.selectedFlow === 'pickup',
      slideInto: this.state.isBackClicked === true,
    });

    const deliveryScreenClass = classNames({
      'sot-inner-box': true,
      'section-address-search': true,
      slideRight: this.state.selectedFlow === 'delivery',
      slideInto: this.state.isBackClicked === true,
    });

    const aboutScreenClass = classNames({
      'sot-inner-box': true,
      'section-pickup-location': true,
      slideRight: this.state.selectedFlow === 'about',
      slideInto: this.state.isBackClicked === true,
    });

    const tableBookingClass = classNames({
      'sot-inner-box': true,
      'section-pickup-location': true,
      slideRight: this.state.selectedFlow === 'tableBooking',
      slideInto: this.state.isBackClicked === true,
    });

    const logoImage = getImage(storeConfig.logoPath || storeConfig.logo);

    return (
      <React.Fragment>
        <div className='section-order-type' id='section-order-type'>
          {this.state.selectedFlow === 'initial' && (
            <React.Fragment>
              <div className={initialScreenClass}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '5rem',
                    minHeight: '58px',
                  }}
                >
                  <img
                    src={logoImage}
                    alt='store-logo'
                    width={260}
                    height={'auto'}
                  />
                </div>
                <h2 className='sot-title'>Select Order Type</h2>
                <ul className='sot-item-list'>
                  {this.props.settings &&
                    this.props.settings.some((s) => {
                      return s.isPickupOn === true;
                    }) && (
                      <li onClick={() => this.setSelectedFlow('pickup')}>
                        <a
                          href='javascript:void(0)'
                          title='Pickup'
                          className='item-box'
                        >
                          <span className='inner-box'>
                            <span className='item-icon-box red'>
                              <span className='item-icon sot_icon_Bag'></span>
                            </span>
                            <span className='item-title'>Pickup</span>
                          </span>
                        </a>
                      </li>
                    )}
                  {this.props.settings &&
                    this.props.settings.some((s) => {
                      return s.isDeliveryOn === true;
                    }) && (
                      <li onClick={() => this.setSelectedFlow('delivery')}>
                        <a
                          href='javascript:void(0)'
                          title='Delivery'
                          className='item-box'
                        >
                          <span className='inner-box'>
                            <span className='item-icon-box orange'>
                              <span className='item-icon sot_icon_Scooter'></span>
                            </span>
                            <span className='item-title'>Delivery</span>
                          </span>
                        </a>
                      </li>
                    )}
                </ul>
                <h2 className='sot-title'>More</h2>
                <ul className='sot-item-list'>
                  <li onClick={() => this.setSelectedFlow('about')}>
                    <a
                      href='javascript:void(0)'
                      title='About'
                      className='item-box'
                    >
                      <span className='inner-box'>
                        <span className='item-icon-box pink'>
                          <span className='item-icon sot_icon_Store'></span>
                        </span>
                        <span className='item-title'>About</span>
                      </span>
                    </a>
                  </li>
                  {this.props.settings &&
                    this.props.settings.some((s) => {
                      return s.isTableBookingOn === true;
                    }) && (
                      <li onClick={() => this.setSelectedFlow('tableBooking')}>
                        <a
                          href='javascript:void(0)'
                          title='Table Bookings'
                          className='item-box'
                        >
                          <span className='inner-box'>
                            <span className='item-icon-box blue'>
                              <span className='item-icon sot_icon_Table'></span>
                            </span>
                            <span className='item-title'>Table Bookings</span>
                          </span>
                        </a>
                      </li>
                    )}
                </ul>
              </div>
            </React.Fragment>
          )}
          {this.state.selectedFlow === 'pickup' && (
            <React.Fragment>
              <div className={pickupScreenClass} id='section-pickup-location'>
                <div className='spl-top-box'>
                  <button
                    className='back-spl-btn sot_icon_'
                    title='Back'
                    onClick={this.handleBackClickFromPickup}
                  ></button>
                </div>
                <div className='spl-inner-box'>
                  <h2 className='spl-title'>Select Pickup Location</h2>
                  <ul className='spl-item-list'>
                    {this.state.availablePickupStores &&
                      this.state.availablePickupStores.length > 0 &&
                      this.state.availablePickupStores.map((s) => {
                        return (
                          <React.Fragment key={s._id}>
                            <li>
                              <a
                                href='#'
                                title={`${s.area}`}
                                className='item-box'
                                onClick={(e) =>
                                  this.openStoreWebsite(
                                    e,
                                    `${s.baseUrl}/?type=pickup`
                                  )
                                }
                              >
                                <span className='inner-box'>
                                  <span
                                    className='item-photo-box'
                                    style={{
                                      backgroundImage: `url(${s.storePhotoURL})`,
                                    }}
                                  >
                                    <span className='item-photo-inner'></span>
                                  </span>
                                  <span className='item-title'>{`${s.name} - ${s.area}`}</span>
                                  {s.distance && (
                                    <span className='item-distance'>
                                      {s.distance} km
                                    </span>
                                  )}
                                  <span className='item-address'>
                                    {`${s.street}`}
                                  </span>
                                </span>
                              </a>
                            </li>
                          </React.Fragment>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
          {this.state.selectedFlow === 'delivery' && (
            <React.Fragment>
              <div className={deliveryScreenClass} id='section-address-search'>
                <div className='sas-top-box'>
                  <button
                    className='back-sas-btn sot_icon_'
                    title='Back'
                    onClick={this.handleBackClickFromDelivery}
                  ></button>
                </div>
                <div className='sas-inner-box'>
                  <h2 className='sas-title'>Enter Delivery Address</h2>
                  <div className='sas-search-wrap'>
                    <div className='sas-search-box'>
                      {/* <button
                        type='reset'
                        className='btn-close'
                        title='Clear'
                      ></button> */}
                      <Geosuggest
                        country={`${storeConfig.stores[0].countryIdentifier}`}
                        ref={(el) => (this._geoSuggest = el)}
                        onKeyDown={(e) => {
                          if (e.keyCode === 9) {
                            e.preventDefault();
                            return;
                          }
                        }}
                        onChange={(_value) => {}}
                        queryDelay={0}
                        autoActivateFirstSuggest={true}
                        autoComplete={'address'}
                        location={
                          new window.google.maps.LatLng(
                            storeConfig.stores[0].addressLocation.lat,
                            storeConfig.stores[0].addressLocation.long
                          )
                        }
                        radius={50000}
                        initialValue={''}
                        inputClassName='input-style'
                        placeholder='Enter delivery address'
                        // suggestsClassName={'autoSuggestionWrap'}
                        minLength={3}
                        highlightMatch={true}
                        skipSuggest={this.skipSuggest}
                        style={{
                          suggestItem: {},
                        }}
                        renderSuggestItem={(suggest) => {
                          return (
                            <React.Fragment>
                              <ul className='sas-restaurant-result-list'>
                                <li>
                                  <h3 className='sas-single-result'>
                                    {suggest.description
                                      .replace(
                                        `, ${storeConfig.stores[0].country}`,
                                        ''
                                      )
                                      .replace(/QLD$/, '')
                                      .replace(/VIC$/, '')
                                      .replace(/NSW$/, '')
                                      .replace(/TAS$/, '')
                                      .replace(/WA$/, '')
                                      .replace(/SA$/, '')
                                      .replace(/NT$/, '')
                                      .replace(/Street /gi, 'St ')
                                      .replace(/Court /gi, 'Crt ')}
                                  </h3>
                                </li>
                              </ul>
                            </React.Fragment>
                          );
                        }}
                        onSuggestNoResults={() =>
                          this.setState({ start: false })
                        }
                        onSuggestSelect={(suggest) =>
                          this.updateDeliveryAddress(suggest)
                        }
                        getSuggestLabel={(suggest) =>
                          suggest.description
                            .replace(`, ${storeConfig.stores[0].country}`, '')
                            .replace(/QLD$/, '')
                            .replace(/VIC$/, '')
                            .replace(/NSW$/, '')
                            .replace(/TAS$/, '')
                            .replace(/WA$/, '')
                            .replace(/SA$/, '')
                            .replace(/NT$/, '')
                            .replace(/Street /gi, 'St ')
                            .replace(/Court /gi, 'Crt ')
                        }
                      />
                    </div>
                  </div>
                  {this.state.showAreaNotServicableMessage === true && (
                    <div
                      style={{
                        marginTop: '4rem',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <h4>Address Not Servicable!</h4>
                    </div>
                  )}
                  <ul className='spl-item-list' style={{ marginTop: '4rem' }}>
                    {this.props.stores &&
                      this.props.stores.length > 0 &&
                      this.props.stores.map(
                        (s) =>
                          this.storeAvailableForService(s, 'delivery-list') && (
                            <li key={s._id}>
                              <a
                                href='#'
                                title={`${s.area}`}
                                className='item-box'
                                onClick={(e) => this.openStoreWebsiteDel(e, s)}
                              >
                                <span className='inner-box'>
                                  <span
                                    className='item-photo-box'
                                    style={{
                                      backgroundImage: `url(${s.storePhotoURL})`,
                                    }}
                                  >
                                    <span className='item-photo-inner'></span>
                                  </span>
                                  <span className='item-title'>{`${s.name} - ${s.area}`}</span>
                                  <span className='item-address'>
                                    {`${s.street}`}
                                  </span>
                                </span>
                              </a>
                            </li>
                          )
                      )}
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
          {this.state.selectedFlow === 'about' && (
            <React.Fragment>
              <div className={aboutScreenClass} id='section-pickup-location'>
                <div className='spl-top-box'>
                  <button
                    className='back-spl-btn sot_icon_'
                    title='Back'
                    onClick={this.handleBackClickFromPickup}
                  ></button>
                </div>
                <div className='spl-inner-box'>
                  <h2 className='spl-title'>About</h2>
                  <ul className='spl-item-list'>
                    {this.props.stores &&
                      this.props.stores.length > 0 &&
                      this.props.stores.map(
                        (s) =>
                          this.storeAvailableForService(s, 'about') && (
                            <li key={s._id}>
                              <a
                                href='#'
                                title={`${s.area}`}
                                className='item-box'
                                onClick={(e) =>
                                  this.openStoreWebsite(
                                    e,
                                    `${s.baseUrl}/?type=about`
                                  )
                                }
                              >
                                <span className='inner-box'>
                                  <span
                                    className='item-photo-box'
                                    style={{
                                      backgroundImage: `url(${s.storePhotoURL})`,
                                    }}
                                  >
                                    <span className='item-photo-inner'></span>
                                  </span>
                                  <span className='item-title'>{`${s.name} - ${s.area}`}</span>
                                  <span className='item-address'>
                                    {`${s.street}`}
                                  </span>
                                </span>
                              </a>
                            </li>
                          )
                      )}
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
          {this.state.selectedFlow === 'tableBooking' && (
            <React.Fragment>
              <div className={tableBookingClass} id='section-pickup-location'>
                <div className='spl-top-box'>
                  <button
                    className='back-spl-btn sot_icon_'
                    title='Back'
                    onClick={this.handleBackClickFromPickup}
                  ></button>
                </div>
                <div className='spl-inner-box'>
                  <h2 className='spl-title'>Table Booking</h2>
                  <ul className='spl-item-list'>
                    {this.props.stores &&
                      this.props.stores.length > 0 &&
                      this.props.stores.map(
                        (s) =>
                          this.storeAvailableForService(s, 'tablebooking') && (
                            <li key={s._id}>
                              <a
                                href='#'
                                title={`${s.area}`}
                                className='item-box'
                                onClick={(e) =>
                                  this.openStoreWebsite(
                                    e,
                                    `${s.baseUrl}/?type=booking`
                                  )
                                }
                              >
                                <span className='inner-box'>
                                  <span
                                    className='item-photo-box'
                                    //style='background-image: url(img/location_img_5.jpg);'
                                  >
                                    <span className='item-photo-inner'></span>
                                  </span>
                                  <span className='item-title'>{`${s.name} - ${s.area}`}</span>
                                  <span className='item-address'>
                                    {`${s.street}`}
                                  </span>
                                </span>
                              </a>
                            </li>
                          )
                      )}
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default OrderType;
